"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "10", height: "10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H0v4h4V0zm6 0H6v4h4V0zM0 6h4v4H0V6zm10 0H6v4h4V6z", fill: "#404040" }))); };
exports.default = Component;
//# sourceMappingURL=Grid.js.map